import styles from "./DeleteConfirmation.module.css";
import Backdrop from "../Dialog/Backdrop";

export const SetAvailableConfirmation = ({ show, handleCancel, handleConfirm, productCount }) => {
  return show ? (
    <div>
      <Backdrop show={show} switch={handleCancel} />
      <div className={styles.deleteDialog}>
        <h2 className={styles.deleteTitle}>Set Products Available</h2>
        <p className={styles.deleteMessage}>
          Are you sure you want to set {productCount} {productCount === 1 ? 'product' : 'products'} as available?
        </p>
        <div className={styles.buttonContainer}>
          <button className={styles.cancelButton} onClick={handleCancel}>
            Cancel
          </button>
          <button className={styles.deleteButton} onClick={handleConfirm}>
            Yes, Set Available
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

